module.exports = __webpack_public_path__ + "img/amex_logo.4eee3e56.svg";